<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.uploadItemWithIA' | translate}}</span>
        </div>
        <div class="td-cnt-body-ia">
            <ng-container *ngIf="!isUploading">
                <input #fileInput type="file" class="file-input" (change)="onFileSelected($event)">
                <div class="file-drop-zone" (dragover)="onDragOver($event)" (drop)="onFileDrop($event)"
                    (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)"
                    [ngClass]="{'dragging': isDragging}">
                    <i class="fal fa-arrow-up-from-bracket"></i>
                    <p>{{'enquiryBook.uploadItemWithIAPlaceholder' | translate}}</p>
                    <p *ngIf="selectedFileName" class="selected-file">
                        {{ 'enquiryBook.uploadItemWithIASelectedFile' | translate: { fileName: selectedFileName } }}
                    </p>
                    <teiasoft-button (onClick)="fileInput.click()" [type]="'tb-secondary'"
                        [text]="'commons.uploadFile' | translate" [isMobile]="isMobile"></teiasoft-button>
                </div>
            </ng-container>
            <div *ngIf="isUploading" class="uploading-status">
                <p>{{ 'enquiryBook.uploadItemsCountAbout' | translate: { itemsCount: itemsCount } }}</p>
                <p>{{ processedItems }} / {{ itemsCount }}</p>
                <p>{{ estimatedTimeStr }}</p>

                <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>

                <p *ngIf="processTakingLonger" class="warning">
                    {{ 'enquiryBook.uploadTakingLonger' | translate }}
                </p>
            </div>
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [isMobile]="isMobile" class="mr-5"></teiasoft-button>
            <teiasoft-button *ngIf="!isUploading" (onClick)="onSaveClick()" [type]="'tb-primary'"
                [text]="'commons.generate' | translate" [isMobile]="isMobile"
                [disabled]="!selectedFileName"></teiasoft-button>
        </div>
    </div>
</div>
